import * as ActionTypes from '../actions/index';
import {fromJS} from "immutable";
import {createReducer} from "./index";

const INITIAL_STATE = fromJS({
  fetching: false,
  labels: [],
  total: 0,
  page: 1,
  rowsPerPage: 10,
  orderBy: 0,
  order: 'desc',
  errorMessage: undefined,
  tempImage: undefined,
  changedLabel: undefined,
});

function getLabels(state, action) {
  return state.set('fetching', true);
}

function getLabelsSuccess(state, action) {
  return state
    .set('fetching', false)
    .set('labels', fromJS(action.payload.body))
}

function getLabelsFailed(state, action) {
  return state.set('fetching', false);
}

function countLabels(state, action) {
  return state; // TODO: Why????
}

function countLabelsSuccess(state, action) {
  return state
    .set('total', action.payload.body.count)
}

function countLabelsFailed(state, action) {
  return state;
}

function storeTemporaryLabelImage(state, action) {
  return state.set('tempImage', action.payload)
}

function createLabel(state, action) {
  return state;
}

function createLabelSuccess(state, action) {
  return state
    .set('tempImage', undefined)
}

function createLabelFailed(state, action) {
  return state;
}

function clearLabelTempImage(state, action) {
  return state.set('tempImage', undefined)
}

function changeLabelPreferences(state, action) {
  return state
    .set(action.payload.key, fromJS(action.payload.value))
}

function changeLabelsOrder(state, action) {
  return state
    .set('order', action.payload.order)
    .set('orderBy', action.payload.orderBy)
}

function storeTemporaryProductLabelImage(state, action) {
  return state.set('tempImage', action.payload);
}

function editLabel(state, action) {
  return state;
}

function editLabelFailed(state, action) {
  return state;
}

function copyLabelForEdit(state, action) {
  const labelId = action.payload;
  const label = state
    .get('labels').valueSeq().toArray()
    .filter(labelImmutable =>
      String(labelImmutable.get('id')) === String(labelId))[0];
  return state.set('changedLabel', label );
}

function editLabelField(state, action) {
  return state
    .setIn(['changedLabel', action.payload.field], action.payload.value);
}

function deleteLabelFailed(state, action) {
    let errorMessage = null;
    try {
      errorMessage = action.payload.response.body.error.message
    } catch (e) {
      errorMessage = 'Failed to delete the label'
    }

    return state
      .set('errorMessage', errorMessage)
}

function clearProductLabelDeleteErrorMessage(state, action) {
  return state.set('errorMessage', undefined);
}

export const productLabels = createReducer(INITIAL_STATE, {
  [ActionTypes.GET_PRODUCTS_LABELS]: getLabels,
  [ActionTypes.GET_PRODUCTS_LABELS_SUCCESS]: getLabelsSuccess,
  [ActionTypes.GET_PRODUCTS_LABELS_FAILED]: getLabelsFailed,
  [ActionTypes.COUNT_PRODUCTS_LABELS]: countLabels,
  [ActionTypes.COUNT_PRODUCTS_LABELS_SUCCESS]: countLabelsSuccess,
  [ActionTypes.COUNT_PRODUCTS_LABELS_FAILED]: countLabelsFailed,
  [ActionTypes.CREATE_BRAND]: createLabel,
  [ActionTypes.CREATE_BRAND_SUCCESS]: createLabelSuccess,
  [ActionTypes.CREATE_BRAND_FAILED]: createLabelFailed,
  [ActionTypes.STORE_TEMPORARY_BRAND_IMAGE]: storeTemporaryLabelImage,
  [ActionTypes.CHANGE_LABELS_PREFERENCES]: changeLabelPreferences,
  [ActionTypes.CHANGE_LABELS_ORDER]: changeLabelsOrder,
  [ActionTypes.CLEAR_PRODUCTS_LABELS_FORM]: clearLabelTempImage,
  [ActionTypes.STORE_TEMPORARY_PRODUCT_LABEL_IMAGE]: storeTemporaryProductLabelImage,
  [ActionTypes.EDIT_LABEL]: editLabel,
  [ActionTypes.EDIT_LABEL_FAILED]: editLabelFailed,
  [ActionTypes.COPY_LABEL_FOR_EDIT]: copyLabelForEdit,
  [ActionTypes.EDIT_LABEL_FIELD]: editLabelField,
  [ActionTypes.CLEAR_TEMP_UPLOADED_PRODUCT_LABEL]: clearLabelTempImage,
  [ActionTypes.DELETE_LABEL_FAILED]: deleteLabelFailed,
  [ActionTypes.CLEAR_PRODUCT_LABEL_DELETE_ERROR_MESSAGE]: clearProductLabelDeleteErrorMessage,
});



// WEBPACK FOOTER //
// ./src/reducers/productLabels.js